goog.provide("shadow.js.shim.module$src$svg$wpp$content$cart_svg$default");
shadow.js.shim.module$src$svg$wpp$content$cart_svg$default = shadow.js.shim.module$src$svg$wpp$content$cart_svg.default;
